import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './BufferSyncReport.css';

/**
 * Pop-up shown when a buffer sync finishes. It stays until the coach closes it (✕, the button, tapping outside or
 * Escape) - the old inline message vanished after 5 seconds, easy to miss.
 */
const ICONS = { success: '✅', warning: '⚠️', error: '❌' };

const BufferSyncReport = ({ report, onClose }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return createPortal(
    <div className="bsr-overlay" onClick={onClose}>
      <div className={`bsr-card bsr-${report.kind}`} role="alertdialog" aria-label={report.title} onClick={(e) => e.stopPropagation()}>
        <div className="bsr-top">
          <span className="bsr-icon" aria-hidden="true">{ICONS[report.kind] || '✅'}</span>
          <h3 className="bsr-title">{report.title}</h3>
          <button type="button" className="bsr-x" onClick={onClose} aria-label="Close">✕</button>
        </div>
        <ul className="bsr-lines">
          {report.lines.map((line, i) => <li key={i}>{line}</li>)}
        </ul>
        {report.seconds != null && <div className="bsr-time">Took {report.seconds < 10 ? report.seconds.toFixed(1) : Math.round(report.seconds)} s</div>}
        <button type="button" className="bsr-close" onClick={onClose} autoFocus>Close</button>
      </div>
    </div>,
    document.body
  );
};

export default BufferSyncReport;
